import type { SystemStyleObject } from '@chakra-ui/react';

// Pressed looks. A tap lasts about 50ms and releasing often closes the
// modal, so each look is on the moment a finger lands, with no fade in.
// Outlined buttons fill with their outline colour and their text goes dark
// (a secondary button looks primary); filled ones sink; quiet icon and row
// buttons get a light wash; bare text and numbers dim. Radios and segmented
// controls have none: the choice itself shows on release. The shared values
// are CSS variables (customTheme.ts) so plain-CSS buttons use them too.
export const PRESSED = '&:active:not(:disabled, [aria-disabled=true])';

const pressed = (look: SystemStyleObject): SystemStyleObject => ({
  [PRESSED]: { transition: 'none', ...look },
});

/** Outlined: fills with `fill`; text and icons go dark. */
export const pressFill = (
  fill: string,
  look: SystemStyleObject = {},
): SystemStyleObject =>
  pressed({
    background: fill,
    color: 'var(--spades-background)',
    '& *': { color: 'inherit' },
    '& svg': { stroke: 'currentColor' },
    ...look,
  });

/** Filled: darker, with the shadow inside. */
export const pressSink = pressed({
  filter: 'var(--press-sink)',
  boxShadow: 'var(--press-sink-shadow)',
});

/** Quiet icon and row buttons: a light wash. */
export const pressWash = pressed({ backgroundColor: 'var(--press-wash)' });

/** Bare text and numbers. */
export const pressDim = pressed({ opacity: 'var(--press-dim)' });
